// app.js
require('./bootstrap');

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import { createApp } from 'vue';
import store from './store';
import { mask } from 'vue-the-mask';


const app = createApp({});

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default));

app.directive('mask', mask);

app.use(store);

app.mount('#app');
